import { render, staticRenderFns } from "./InvoiceOrder.vue?vue&type=template&id=3321b2ec&scoped=true"
import script from "./InvoiceOrder.vue?vue&type=script&lang=js"
export * from "./InvoiceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3321b2ec",
  null
  
)

export default component.exports